import {AxisCellModelContext} from 'notebook/tables/store/contexts/AxisCellModelContext';
import {AxisCellModel} from 'notebook/tables/store/models/AxisCellModel';

export function useAxisCellModel(): AxisCellModel;
export function useAxisCellModel<T>(subSelector: (axisCellModel: AxisCellModel) => T): T;
export function useAxisCellModel<T>(subSelector?: (axisCellModel: AxisCellModel) => T): T {
  const {useAxisCellModelSlice} = AxisCellModelContext.useContext();
  return useAxisCellModelSlice((axisCellModel) =>
    subSelector ? subSelector(axisCellModel) : (axisCellModel as T)
  );
}
